<cb-mini-title class="mini-title" *ngIf="data.title" [title]="data.title" [withFrame]="!isFirstSlice"></cb-mini-title>

<form [formGroup]="form" class="form" (ngSubmit)="checkRecaptcha()">
  <h2>Identité</h2>
  <div formFieldControl id="civilTitle">
    <fieldset>
      <legend>Civilité*</legend>
      <div formFieldRadioGroup class="form-field-control--half-size">
        <form-field-radio name="civilTitle" formControlName="civilTitle" value="Mme">
          <span class="ic ic-woman civil-icon"></span>
          Madame
          <div class="check-icon">
            <span class="ic-check"></span>
          </div>
        </form-field-radio>
        <form-field-radio name="civilTitle" formControlName="civilTitle" value="M" class="form-field-radio--right">
          <span class="ic ic-man civil-icon"></span>
          Monsieur
          <div class="check-icon">
            <span class="ic-check"></span>
          </div>
        </form-field-radio>
      </div>
      <form-field-error></form-field-error>
    </fieldset>
  </div>

  <div formFieldControl id="lastName" class="form-field-control--half-size">
    <label for="lastName"> Nom* </label>
    <input formControlName="lastName" name="lastName" type="text" placeholder="Dupont" formFieldInput />
    <form-field-error></form-field-error>
  </div>
  <div formFieldControl id="firstName" class="form-field-control--half-size form-field-control--right">
    <label for="firstName">Prénom* </label>
    <input placeholder="Antoine" type="text" name="firstName" formControlName="firstName" formFieldInput />
    <form-field-error></form-field-error>
  </div>

  <div formFieldControl id="email" class="form-field-control--half-size">
    <label for="email"> E-mail* </label>
    <input formControlName="email" name="email" type="email" formFieldInput placeholder="exemple@mail.com" />
    <form-field-error></form-field-error>
  </div>

  <div formFieldControl id="phone" class="form-field-control--half-size form-field-control--right">
    <label for="phone"> Numéro de téléphone* </label>
    <input
      formControlName="phone"
      name="phone"
      type="text"
      formFieldInput
      inputmode="numeric"
      pattern="[0-9]*"
      mask="00 00 00 00 00"
      placeholder="01 23 45 67 89"
    />
    <form-field-error></form-field-error>
  </div>

  <div formFieldControl id="postalCode" class="form-field-control--half-size--block">
    <label for="postalCode">Code postal* </label>
    <input
      placeholder="75011"
      formControlName="postalCode"
      name="postalCode"
      formFieldInput
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      mask="00000"
    />
    <form-field-error></form-field-error>
  </div>

  <div formFieldControl class="hide-item">
    <label for="providerCode">
      <input id="providerCode" formControlName="providerCode" name="providerCode" formFieldInput type="text" />
    </label>
  </div>

  <div formFieldControl class="hide-item">
    <label for="emailRedirection">
      <input formControlName="emailRedirection" name="emailRedirection" formFieldInput type="text" />
    </label>
  </div>

  <div formFieldControl class="hide-item">
    <label for="recipt">
      <input formControlName="recipt" name="recipt" formFieldInput />
    </label>
  </div>

  <div class="text-checkbox-container">
    <span [class.checkbox-field-error--hidden]="_hideCheckboxError" class="checkbox-field--error"
      >Champ obligatoire</span
    >
    <div formFieldControl id="textRadioButton">
      <fieldset>
        <form-field-checkbox
          formControlName="textRadioButton"
          (valueChanged)="getCheckBoxValue($event)"
          class="filter is-open-saturday-checkbox"
        >
        </form-field-checkbox>
      </fieldset>
    </div>
    <span [innerHTML]="data.text_radio_button"></span>
  </div>

  <p class="mandatory-field-text">*Champs obligatoires</p>
  <p [innerHTML]="data.text_rgpd"></p>

  <div class="button-wrapper">
    <cb-cta-btn-link
      class="button"
      [button]="button"
      [buttonWithoutLink]="true"
      [sliceType]="data.type"
      [disabled]="_buttonDisabled"
    ></cb-cta-btn-link>
    <form-field-error
      class="post-error"
      [class.shown]="_hasPostError"
      message="Erreur dans l'envoi de votre demande. Merci de réessayer ultérieurement"
    >
    </form-field-error>
    <p class="recaptcha-mentions">
      Ce site est protégé par reCAPTCHA. Les
      <a href="https://policies.google.com/privacy">règles de confidentialité</a>
      et les
      <a href="https://policies.google.com/terms">conditions d'utilisation</a>
      de Google s'appliquent.
    </p>
  </div>
</form>
